import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './exportStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import WireDistanceWarning from 'components/Wire/DistanceWarning'
import DescriptionBuilder from 'components/DeviceDescription/DescriptionBuilder'
import { exportWireDistanceSelector, currentWiredDeviceSelector, exportWireEndDeviceSelector } from 'selectors/components'

const mapStateToProps = state => {
  const distanceResult = exportWireDistanceSelector(state)

  return {
    currentWiredDevice: currentWiredDeviceSelector(state),
    networkCloset: exportWireEndDeviceSelector(state),
    wireDistance: distanceResult && distanceResult.distance,
    showWarning: distanceResult && distanceResult.showWarning,
    isImperial: state.ui.isImperial
  }
}

const WiredDeviceExportDetails = ({ currentWiredDevice, networkCloset, wireDistance, showWarning, isImperial, classes }) =>
  <div className={classes.details}>
    { networkCloset
      ? <div className={classes.wiringInfo}>
          <strong>Cable Calculations:</strong>
          <span>
            <FontAwesomeIcon
              icon='server'
              className={classes.networkClosetIcon}
              style={{ color: networkCloset.color }}
            />
            { networkCloset.name }
          </span>
          <span>
            Length: { wireDistance }
            { showWarning && <WireDistanceWarning isImperial={isImperial} /> }
          </span>
        </div>
      : <div className={classes.wiringInfo}>
          <strong>Cable Calculations:</strong>
          <em>No connection</em>
        </div>
    }
    <span><strong>Manufacturer: </strong>{currentWiredDevice.manufacturer}</span>
    <span><strong>Model: </strong>{currentWiredDevice.model}</span>
    <DescriptionBuilder currentDevice={currentWiredDevice} type='wiredDevice' isExport />
  </div>

export default connect(mapStateToProps)(injectSheet(style)(WiredDeviceExportDetails))



// WEBPACK FOOTER //
// ./src/components/WiredDeviceDetails/exportDetails.js